// Components==============
import React, { useState } from 'react';
import './RichTextEditor.module.scss';

import RichTextEditor, { EditorValue } from 'react-rte';
// =========================

const textEditorToolbarConfig = {
  display: ['INLINE_STYLE_BUTTONS'],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
    { label: 'Italic', style: 'ITALIC' },
    { label: 'Underline', style: 'UNDERLINE' },
  ],
};

export default function RichtTextEditor({
  initial,
  onChange,
}: {
  initial: string;
  onChange: (val: string) => void;
}) {
  const [value, setValue] = useState(
    RichTextEditor.createValueFromString(
      initial.replace(/<a href="(.*)">(.*)<\/a>/, '$2'),
      'html'
    ) || RichTextEditor.createEmptyValue()
  );

  function handleChange(val: EditorValue) {
    setValue(val);
    onChange(
      val.toString('html').replace(
        // eslint-disable-next-line
        /\b(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*))\S+/gi,
        '<a href="$1" target="_blank">$1</a>'
      )
    );
  }

  return (
    <RichTextEditor
      styleName="editor"
      // @ts-ignore
      toolbarConfig={textEditorToolbarConfig}
      value={value}
      onChange={(e) => handleChange(e)}
    />
  );
}
